<div class="flex-row flex-gap-20">

    <mat-icon [ngClass]="{'green-icon': type === 'info', 'yellow-icon': type === 'warning', 'red-icon': type === 'error'}">{{type}}</mat-icon>
    <span class="text">{{message}}</span>

</div>
